import { Component, OnInit } from '@angular/core';
import { AppMemoryService } from './../../core/app-memory.service';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.less']
})
export class ActivityComponent implements OnInit {
  public colors = {
    pending:'yellow',
    canceled:'red',
    approved:'blue',
    opened:'green'
  }
  constructor(public appMemory:AppMemoryService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/activity/activity.component.ts